const messages = {
  crop_source_unsupported: 'Choose a JPEG, PNG or WebP image.',
  crop_source_private: 'Private images cannot be cropped for public use.',
  crop_source_ineligible: 'This source is not available for public cropping.',
  crop_source_changed: 'The source changed. Reopen the editor and try again.',
  crop_storage_failed: 'Storage could not save the copy. Try saving again.',
  crop_source_unavailable: 'The original is no longer eligible. Refresh the library.',
  crop_not_found: 'This saved crop recipe is unavailable.',
  crop_source_missing: 'The original image is no longer available.',
  crop_source_is_crop: 'Reopen this copy from its original image.',
  crop_source_too_large: 'Choose an image smaller than 40 MB.',
  crop_source_unreadable: 'The image could not be read. Try another image.',
  crop_too_small: 'Zoom out: the selection must be at least 32 pixels on each side.',
  crop_rect_invalid: 'Keep the selection inside the image.',
  crop_ratio_mismatch: 'The selection must match the selected shape. Try resetting it.',
  crop_preset_invalid: 'Choose a supported crop shape.',
  crop_busy: 'The crop service is busy. Try again in a few seconds.',
  crop_rate_limited: 'Too many crops were saved. Try again in ten minutes.',
  crop_source_mismatch: 'This copy does not match the placement’s current original image.',
  crop_preset_mismatch: 'This copy uses a different crop shape from this placement.',
};
export function cropMessage(error) {
  return messages[error.code] || error.message || 'Unable to save the crop. Try again.';
}
export function createCropApi({fetch, API_URL}) {
  const request = async (path, body) => {
    const response = await fetch(`${API_URL}/v1/seller/${path}`, body === undefined ? {} : {
      method: path.includes('/crops') ? 'POST' : 'PUT',
      headers: {'Content-Type': 'application/json'}, body: JSON.stringify(body),
    });
    const payload = await response.json().catch(() => ({}));
    if (!response.ok) throw Object.assign(new Error(payload.error || 'Unable to load or save crop data.'),
      {code: payload.code, data: payload.data});
    return payload;
  };
  return {
    reopen: uuid => request(`media/${encodeURIComponent(uuid)}/crop`),
    create: (uuid, preset, rect) => request(`media/${encodeURIComponent(uuid)}/crops`, {preset, rect}),
    storefront: () => request('storefront'),
    product: id => request(`products/${encodeURIComponent(id)}`),
    attachStorefront: (slot, file) => request('storefront/imagery-crops', {crops: {[slot]: file ? {fileUuid: file.uuid} : null}}),
    attachProduct: (id, file) => request(`products/${encodeURIComponent(id)}/listing-image`, file ? {fileUuid: file.uuid} : null),
  };
}
